module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/btn-cta-cadfc9fc1b76e8969ea167f8b67f6a19.svg";